import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DOCUMENT } from "@angular/platform-browser";
import { GrowlModule } from "primeng/primeng";

import { NgToastrComponent } from "./ng-toastr.component";
import { NgToastrService } from "./ng-toastr.service";

function NgToastrServiceFactory(document: Document): NgToastrService {
    return NgToastrService.getInstance(document);
}

@NgModule({
    imports: [
        CommonModule,
        GrowlModule
    ],
    declarations: [
        NgToastrComponent
    ],
    providers: [
        {
            provide: NgToastrService,
            useFactory: NgToastrServiceFactory,
            deps: [DOCUMENT]
        }
    ],
    exports: [
        NgToastrComponent
    ]
})
export class NgToastrModule {
}
